<template>
  <!-- The welcome text of a logged in sso user, shown below the header at every width -->
  <div
    v-if="ssoStore.isAvailable && ssoStore.isLoggedIn"
    class="border-b border-surface-grey"
  >
    <BaseContainer>
      <p class="py-4 text-base font-medium text-headings wrap-anywhere">
        {{ welcomeText }}
      </p>
    </BaseContainer>
  </div>
</template>

<script setup lang="ts">
  import { useSsoStore } from '@/stores/sso';
  import { useSsoWelcomeText } from '@/utils/useSsoWelcomeText';

  import BaseContainer from '../ui/BaseContainer.vue';

  const ssoStore = useSsoStore();
  const welcomeText = useSsoWelcomeText();
</script>
